import { useState, useEffect } from "react";
import "./HomeChefLandingPage.css";
import RegistrationModal from "./components/RegistrationModal";

import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import your images - adjust paths as needed for your project
import heroDish from "./assets/hero-dish.jpg";
import chefPortrait from "./assets/chef-portrait-02.png";
import deliveryBoxes from "./assets/delivery-boxes.jpg";
import analyticsImg from "./assets/analytics.jpg";

// new imports from assets folder
import navbarLogo from "../../Assets/Image/LogoTransparent.png";
import Footer from "../../components/Footer/Footer";
import HomeChefFaq from "./components/HomeChefFaq";
import HomeChefPricing from "./components/HomeChefPricing";
import HomeChefArchitectureOfGrowth from "./components/HomeChefArchitectureOfGrowth";
import HomeChefPainPoints from "./components/HomeChefPainPoints";
import HomeChefCurationOfExcellence from "./components/HomeChefCurationOfExcellence";
import HomeChefQuantifiableSuccess from "./components/HomeChefQuantifiableSuccess";

import { Link } from "react-router-dom";

/* ───────── Navbar ───────── */
const Navbar = ({ onOpenModal }) => (
  <nav className="hc-navbar">
    <div className="container d-flex align-items-center justify-content-between">
      <Link to="/" className="hc-logo">
        <img src={navbarLogo} alt="GoTaste Logo" className="hc-logo-img" />
        gotaste
      </Link>

      <button onClick={onOpenModal} className="hc-btn hc-btn-primary hc-btn-sm">
        REGISTER NOW
      </button>
    </div>
  </nav>
);

/* ───────── Registration Success Modal ───────── */
const RegistrationSuccessModal = ({ isOpen, redirectionUrl }) => {
  const [countdown, setCountdown] = useState(10);

  const redirect = () => {
    if (redirectionUrl) {
      window.location.href = redirectionUrl;
    }
  };

  useEffect(() => {
    if (!isOpen || !redirectionUrl) return;

    setCountdown(10);
    let remaining = 10;

    const interval = setInterval(() => {
      remaining -= 1;
      setCountdown(remaining);
      if (remaining <= 0) {
        clearInterval(interval);
        window.location.href = redirectionUrl;
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, redirectionUrl]);

  if (!isOpen) return null;

  return (
    <div className="hc-modal-overlay">
      <div
        className="hc-modal-content hc-success-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="hc-success-title">Registration Successful</h2>
        <p className="hc-success-subtitle">Check your Email inbox</p>
        <p className="hc-success-countdown">
          Redirecting in {countdown} second{countdown !== 1 ? "s" : ""}...
        </p>
        <button
          type="button"
          className="hc-btn hc-btn-dark hc-btn-block text-uppercase"
          onClick={redirect}
        >
          Proceed to login
        </button>
      </div>
    </div>
  );
};

/* ───────── Hero ───────── */
const Hero = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [redirectionUrl, setRedirectionUrl] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault(); // Prevents the page from refreshing
    setLoading(true);

    // Prepare the data payload
    const apiAddress = process.env.REACT_APP_SECRET || "https://localhost:7175";

    const payload = {
      id: "F07294B7-C94D-4D5E-A064-B1282D5B5532",
      companyLegalName: "",
      address: "",
      companyRegistrationNumber: "",
      businessTypeId: "Home Cook",
      firstName: firstname,
      surName: lastname,
      phoneNumberCountryCode: "GB",
      phoneNumber: phoneNumber,
      email: email,
      webSiteAddress: "",
      uploadedDocImagePath: "",
      approvalStatusId: "f07294b7-c94d-4d5e-a064-b1282d5b5434", // Approved
    };

    // Send the API Request
    try {
      const url = `${apiAddress}/api/RestaurantRegistration`;
      const response = await axios.post(url, payload);

      if (response.data.message === "Registration successfully.") {
        setRedirectionUrl(response.data.redirectionUrl || "");
        setShowSuccessModal(true);
        setFirstname("");
        setLastname("");
        setEmail("");
        setPhoneNumber("");
      } else if (response.data.message === "OK") {
        toast.success("Registration Successful!");
        setFirstname("");
        setLastname("");
        setEmail("");
        setPhoneNumber("");
      } else {
        toast.error(response.data || "Registration failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <RegistrationSuccessModal
        isOpen={showSuccessModal}
        redirectionUrl={redirectionUrl}
      />
      <section className="hc-hero">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-6 hc-hero-left">
            <p className="hc-hero-tag">The New Standard for Private Chefs</p>
            <h1 className="hc-hero-title">
              Scale Your Kitchen
              <br />
              into a <span className="hc-underline">Global Brand.</span>
            </h1>
            <p className="hc-hero-sub">
              Stop being just a cook. Become a culinary entrepreneur. We provide
              the logistics, the marketing, and the tech to turn your signature
              dishes into a UK-wide legacy.
            </p>
            <img
              src={heroDish}
              alt="Gourmet dish"
              className="hc-hero-img"
              width={480}
              height={380}
            />
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="hc-form-card">
              <div className="hc-form-icon-container">
                <div className="hc-form-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
                      fill="currentColor"
                    />
                    <path
                      d="M18 16L19 19L22 20L19 21L18 24L17 21L14 20L17 19L18 16Z"
                      fill="currentColor"
                      opacity="0.7"
                    />
                    <path
                      d="M6 16L7 19L10 20L7 21L6 24L5 21L2 20L5 19L6 16Z"
                      fill="currentColor"
                      opacity="0.7"
                    />
                  </svg>
                </div>
              </div>

              {/* Overline Text */}
              <span className="hc-section-overline d-block mb-4">
                Share your meal more than 100K plus audience
              </span>
              <h3>Begin Your Expansion</h3>
              <p className="hc-form-sub">
                Create your chef profile and start reaching customers across the
                country in minutes.
              </p>

              <form onSubmit={handleRegister}>
                <input
                  type="text"
                  placeholder="First Name"
                  className="hc-input"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  required
                />

                <input
                  type="text"
                  placeholder="Last Name"
                  className="hc-input"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  required
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  className="hc-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="hc-input"
                  inputMode="numeric"
                  value={phoneNumber}
                  maxLength={15}
                  onChange={(e) =>
                    setPhoneNumber(e.target.value.replace(/\D/g, ""))
                  } // Only allows numbers
                  required
                />

                <button
                  className="hc-btn hc-btn-dark hc-btn-block text-uppercase"
                  type="submit"
                  disabled={loading} // Disables button while loading
                >
                  {loading ? "Processing..." : "Sign Up"}
                </button>
              </form>

              <span className="hc-section-overline d-block text-center mt-4">
                exclusivity guaranteed: selective membership
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

const Marketing = () => {
  const categories = ["GOURMET", "FLAVORLY", "ARTISAN", "BISTRO", "PALATE"];

  return (
    <section className="hc-section-marketing py-5">
      <div className="container text-center">
        {/* Overline Text */}
        <span className="hc-section-overline d-block mb-4">
          POWERING THE FUTURE OF GOURMET COMMERCE
        </span>

        {/* Category Labels Row */}
        <div className="row justify-content-center g-5">
          {categories.map((item, index) => (
            <div key={index} className="col-auto">
              <span className="text-uppercase text-dark small px-3 py-2 rounded">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ───────── Growth Engine ───────── */
const GrowthEngine = () => {
  const cards = [
    {
      img: analyticsImg,
      title: "Profit Analytics",
      desc: "Real-time dashboards to track your margins and optimize your menu for maximum growth.",
    },
    {
      img: deliveryBoxes,
      title: "National Logistics",
      desc: "Cold-chain and express delivery options that let you serve customers far beyond your local neighborhood.",
    },
    {
      img: chefPortrait,
      title: "Professional Branding",
      desc: "We provide premium packaging and digital storefronts that make your home kitchen look like a Michelin-star brand.",
    },
  ];
  return (
    <section className="hc-section hc-section-growthengine">
      <div className="container text-center">
        <h2 className="hc-section-title">Gourmet Growth Engine</h2>
        <div className="row mt-5">
          {cards.map((c, i) => (
            <div className="col-md-4" key={i}>
              <div className="hc-engine-card">
                <img
                  src={c.img}
                  alt={c.title}
                  loading="lazy"
                  width={340}
                  height={220}
                />
                <h5>{c.title}</h5>
                <p>{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ───────── CTA ───────── */
const CTA = ({ onOpenModal }) => (
  <section className="hc-cta">
    <div className="container text-center">
      <h2>
        Ready to Transform Your Culinary
        <br />
        Business?
      </h2>
      <p>
        Join the exclusive network of chefs redefining the UK food industry.
      </p>
      <button onClick={onOpenModal} className="hc-btn hc-btn-outline-light">
        Sign up
      </button>
    </div>
  </section>
);

/* ───────── Main Component ───────── */
const HomeChefLandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Pricing Data State
  const [pricingData, setPricingData] = useState({
    cycles: [],
    plans: [],
    features: [],
  });

  const [isPricingLoading, setIsPricingLoading] = useState(true);

  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const apiBase = process.env.REACT_APP_SECRET || "http://localhost:5000";

        // Fetch all 3 APIs in parallel
        const [cyclesRes, plansRes, featuresRes] = await Promise.all([
          axios.get(
            `${apiBase}/api/SubscriptionPlan/get-all-used-billing-cycles`,
          ),
          axios.get(
            `${apiBase}/api/SubscriptionPlan/get-all-subscription-plan`,
          ),
          axios.get(`${apiBase}/api/SubscriptionPlan/get-all-used-features`),
        ]);

        if (
          cyclesRes.data.success &&
          plansRes.data.success &&
          featuresRes.data.success
        ) {
          setPricingData({
            cycles: cyclesRes.data.data,
            plans: plansRes.data.data,
            features: featuresRes.data.data,
          });
        } else {
          toast.error("Failed to load pricing information.");
        }
      } catch (error) {
        console.error("Error fetching pricing:", error);
        toast.error("Could not connect to pricing service.");
      } finally {
        setIsPricingLoading(false);
      }
    };

    fetchPricingData();
  }, []);

  return (
    <div className="hc-landing">
      <Navbar onOpenModal={() => setIsModalOpen(true)} />
      <Hero />
      <Marketing />
      <HomeChefPainPoints />
      <GrowthEngine />
      <HomeChefCurationOfExcellence />
      <HomeChefQuantifiableSuccess />
      <HomeChefArchitectureOfGrowth />

      <HomeChefPricing
        cycles={pricingData.cycles}
        plans={pricingData.plans}
        allFeatures={pricingData.features}
        isLoading={isPricingLoading}
      />

      <HomeChefFaq />
      <CTA onOpenModal={() => setIsModalOpen(true)} />
      <Footer />

      <RegistrationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default HomeChefLandingPage;
